const MAX_IMAGE_PIXELS = 2000000

export const downscaleImage = (file, maxPixels = MAX_IMAGE_PIXELS) => new Promise((resolve) => {
  const url = URL.createObjectURL(file)
  const image = new Image()
  image.onload = () => {
    URL.revokeObjectURL(url)
    const scale = Math.min(1, Math.sqrt(maxPixels / (image.width * image.height)))
    const canvas = document.createElement('canvas')
    canvas.width = Math.round(image.width * scale)
    canvas.height = Math.round(image.height * scale)
    canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height)
    canvas.toBlob(blob => {
      resolve(blob ? new File([blob], file.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' }) : file)
    }, 'image/jpeg', 0.85)
  }
  image.onerror = () => {
    URL.revokeObjectURL(url)
    resolve(file)
  }
  image.src = url
})
